import { observer } from "mobx-react";
import React from "react";
import RightMenu from "../rightmenu/RightMenu";
export const TopNav = observer((props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("nav", { className: "topnav" },
            React.createElement("div", { className: "navbar-right" }, props.children)),
        React.createElement(RightMenu, { appModel: props.appModel })));
});
export default TopNav;
